import Vue from 'vue';

export default Vue.component('loading-droplet', {
  template: require('./template.html'),
  name: 'loading-droplet',
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/_bubble-options/components/loading-droplet/index.js